import t from"react";import{MdIcon as e}from"./MdIcon.js";import{mdiWechat as o}from"@mdi/js";const r=({id:r="wechat",title:i="WeChat",...m})=>t.createElement(e,{id:r,title:i,path:o,...m});export{r as WechatIcon};
